import React, { ComponentType } from 'react'
import { ErrorHandling } from 'src/error/ErrorHandling'
import { useTran } from 'src/i18n/useTran'
import { msg } from 'src/i18n/texts/keys'

export const AppErrorHandling: ComponentType<{ children: React.ReactNode }> = ({
    children
}) => {
    const t = useTran()
    return (
        // TODO translations
        <ErrorHandling defaultErrorMsg={t(msg.error.weApologize)}>
            {children}
        </ErrorHandling>
    )
}
